(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-content-card"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const DUPLICATE_MESSAGE = 'Not possible to order more than one of each';
    const buttons = document.querySelectorAll('.image-content-card__add-to-cart');

    function findErrorTarget(button) {
      const sectionEl = button.closest('.image-content-card');
      if (!sectionEl) return null;
      return sectionEl.querySelector('.image-content-card__error');
    }

    function showError(button, message) {
      const errorEl = findErrorTarget(button);
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
      clearTimeout(errorEl.__hideTimer);
      errorEl.__hideTimer = setTimeout(function() {
        errorEl.hidden = true;
      }, 5000);
    }

    function clearError(button) {
      const errorEl = findErrorTarget(button);
      if (!errorEl) return;
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    function markBloodInCart() {
      document.querySelectorAll('.image-content-card__add-to-cart, .blood-checkout-btn').forEach(function(btn) {
        btn.dataset.bloodInCart = 'true';
      });
    }

    buttons.forEach(button => {
      button.addEventListener('click', async function(e) {
        e.preventDefault();

        const variantId = this.dataset.variantId;
        if (!variantId) return;

        const isBloodwork = this.dataset.isBloodwork === 'true';
        const bloodInCart = this.dataset.bloodInCart === 'true';

        clearError(this);

        if (isBloodwork && bloodInCart) {
          showError(this, DUPLICATE_MESSAGE);
          return;
        }

        this.classList.add('is-loading');
        this.disabled = true;

        try {
          const cartData = {
            id: variantId,
            quantity: 1
          };

          if (isBloodwork) {
            cartData.properties = {
              '_bloodwork': 'true',
              'Pro2col Labs': ''
            };
          }

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify(cartData)
          });

          if (!response.ok) {
            throw new Error('Failed to add to cart');
          }

          if (isBloodwork) {
            markBloodInCart();
          }

          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              data: {
                source: 'product-form-component',
                itemCount: 1
              }
            }
          }));

        } catch (error) {
          console.error('Error adding to cart:', error);
        } finally {
          this.classList.remove('is-loading');
          this.disabled = false;
        }
      });
    });

    // Sticky bar: show when scrolled past the section, hide near footer
    const stickyBars = document.querySelectorAll('.image-content-card__sticky-bar');
    if (stickyBars.length) {
      function handleScroll() {
        const footer = document.querySelector('footer, .shopify-section-group-footer-group');
        stickyBars.forEach(stickyBar => {
          const barId = stickyBar.id;
          const sectionId = barId.replace('sticky-bar-', '');
          const section = document.querySelector('.image-content-card--' + sectionId);
          if (!section) return;

          const sectionBottom = section.getBoundingClientRect().bottom;
          const footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
          const windowHeight = window.innerHeight;
          const isNearBottom = (window.innerHeight + window.scrollY) >= (document.body.scrollHeight - 100);

          if (sectionBottom < 0 && footerTop > windowHeight && !isNearBottom) {
            stickyBar.classList.add('is-visible');
          } else {
            stickyBar.classList.remove('is-visible');
          }
        });
      }

      window.addEventListener('scroll', handleScroll, { passive: true });
      window.addEventListener('resize', handleScroll);
      handleScroll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Filter product cards by target country SKU suffix
  function filterProductCardsByTargetCountry() {
    const targetCountry = window.data?.profile?.targetCountry;
    if (!targetCountry) {
      // No country data available — show all products rather than a blank page
      return;
    }

    const targetCountryLower = targetCountry.toLowerCase();
    const productCards = document.querySelectorAll('.product-grid__item[data-product-skus]');

    // Pre-compute supported category set so we can apply both filters in one pass
    const resultsEl = document.querySelector('results-list');
    const supportedRaw = resultsEl && resultsEl.getAttribute('data-supported-category-ids');
    let supportedSet = null;
    if (supportedRaw) {
      let supportedIds;
      try {
        const parsed = JSON.parse(supportedRaw);
        supportedIds = Array.isArray(parsed) ? parsed : [String(parsed)];
      } catch (e) {
        supportedIds = supportedRaw.split(',');
      }
      supportedIds = supportedIds.map(id => String(id).trim().toLowerCase()).filter(Boolean);
      if (supportedIds.length > 0) supportedSet = new Set(supportedIds);
    }

    // Single pass: compute country + category visibility together so display is
    // written once — prevents a flash of country-matching cards before category
    // filtering hides the ones that don't belong to this collection.
    const cardVisibility = [];
    let anyMatch = false;

    productCards.forEach(card => {
      const skusString = card.getAttribute('data-product-skus');

      if (!skusString || skusString.trim() === '') {
        cardVisibility.push({ card, visible: false });
        return;
      }

      const skus = skusString.split('|').filter(sku => sku.trim());
      const hasMatchingSku = skus.some(sku => {
        const skuParts = sku.split('_');
        if (skuParts.length < 2) return false;
        return skuParts[skuParts.length - 1].toLowerCase() === targetCountryLower;
      });

      if (!hasMatchingSku) {
        cardVisibility.push({ card, visible: false });
        return;
      }

      // Country matched — now check category if this collection has category filtering
      let visible = true;
      if (supportedSet) {
        const categoryRaw = card.getAttribute('data-variant-category-ids');
        if (!categoryRaw) {
          visible = false;
        } else {
          let variantCategories;
          try {
            const parsed = JSON.parse(categoryRaw);
            variantCategories = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
          } catch (e) {
            visible = false;
          }
          if (visible && (!Array.isArray(variantCategories) || !variantCategories.some(id => supportedSet.has(String(id).trim().toLowerCase())))) {
            visible = false;
          }
        }
      }

      cardVisibility.push({ card, visible });
      if (visible) anyMatch = true;
    });

    // Apply all visibility in one DOM write
    if (!anyMatch) {
      productCards.forEach(card => { card.style.display = 'none'; });
      showNoProductsMessage();
      return;
    }

    cardVisibility.forEach(({ card, visible }) => {
      card.style.display = visible ? '' : 'none';
    });

    const anyVisible = Array.from(productCards).some(card => card.style.display !== 'none');
    if (!anyVisible) {
      showNoProductsMessage();
    } else {
      hideNoProductsMessage();
    }

    // Update prices based on locale-matching variants
    updatePricesByLocale(targetCountryLower);

    // Filter card images by country code in filename
    filterCardImagesByCountry(targetCountryLower);

    // Update option tag counts (Sizes, Flavors) to only count country-matching variants
    updateOptionTagsByCountry(targetCountryLower);

    logLowestPriceVariant(targetCountryLower);
  }

  // Show a single static locale-matching image per card. No carousel, no hover.
  function filterCardImagesByCountry(targetCountryLower) {
    document.querySelectorAll('.product-grid__item').forEach(card => {
      if (card.style.display === 'none') return;

      // Prefer ProductImage from additionalImages variant metafield
      const additionalImagesRaw = card.getAttribute('data-additional-images');
      if (additionalImagesRaw) {
        try {
          const additionalImages = JSON.parse(additionalImagesRaw);
          const productImage = additionalImages.ProductImage;
          if (productImage) {
            const slideshow = card.querySelector('slideshow-component');
            const newImg = document.createElement('img');
            newImg.src = productImage;
            newImg.alt = card.getAttribute('data-product-handle') || '';
            newImg.className = 'collection-single-img';
            if (slideshow) {
              slideshow.replaceWith(newImg);
            }
            return;
          }
        } catch (e) {}
      }

      const slideshow = card.querySelector('slideshow-component');
      if (!slideshow) return;

      const slides = slideshow.querySelectorAll('slideshow-slide');
      if (!slides.length) return;

      let localeImg = null;
      let genericImg = null;

      slides.forEach(slide => {
        const img = slide.querySelector('img');
        if (!img || !img.src) return;

        const filename = img.src
          .split('/').pop()
          .split('?')[0]
          .split('.')[0]
          .toLowerCase()
          .replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/, '');

        const isCountryTagged = filename.includes('pc-') || filename.includes('pn-');

        if (!isCountryTagged) {
          if (!genericImg) genericImg = img;
          return;
        }

        const suffix = filename.split('-').pop();
        if (suffix && suffix.length === 2 && suffix === targetCountryLower && !localeImg) {
          localeImg = img;
        } else if (!genericImg) {
          genericImg = img;
        }
      });

      const source = localeImg || genericImg || slides[0].querySelector('img');
      if (!source || !source.src) {
        showPlaceholderImage(card);
        return;
      }

      // Request a high-resolution image from Shopify CDN
      let src = source.src;
      try {
        const u = new URL(src);
        u.searchParams.set('width', '1200');
        src = u.toString();
      } catch (e) {}

      const newImg = document.createElement('img');
      newImg.src = src;
      newImg.alt = source.alt || '';
      newImg.className = 'collection-single-img';
      slideshow.replaceWith(newImg);
    });
  }

  // Show placeholder image when no country-matching images exist
  function showPlaceholderImage(card) {
    const gallery = card.querySelector('.card-gallery');
    if (!gallery) return;

    // Don't add placeholder twice
    if (gallery.querySelector('.country-placeholder-image')) return;

    const placeholderUrl = document.querySelector('results-list')?.getAttribute('data-placeholder-image') || '';
    if (!placeholderUrl) return;

    const placeholder = document.createElement('div');
    placeholder.className = 'country-placeholder-image';
    placeholder.style.cssText = 'display:flex;align-items:center;justify-content:center;aspect-ratio:var(--gallery-aspect-ratio, 1/1);background:#fff;border-radius:var(--product-corner-radius, 8px);overflow:hidden;';
    placeholder.innerHTML = '<img src="' + placeholderUrl + '" alt="Product placeholder" style="max-width:70%;max-height:70%;object-fit:contain;" />';

    // Hide the slideshow and insert placeholder
    const slideshow = gallery.querySelector('slideshow-component');
    if (slideshow) {
      slideshow.style.display = 'none';
    }
    // Insert at the beginning of the gallery (before slideshow or any other content)
    gallery.insertBefore(placeholder, gallery.firstChild);
  }

  // Update option tag counts to only count variants matching the target country
  // Reads data-variant-options and data-option-map from the <li> product grid item
  function updateOptionTagsByCountry(targetCountryLower) {
    const productCards = document.querySelectorAll('.product-grid__item[data-variant-options]');

    productCards.forEach(card => {
      if (card.style.display === 'none') return;

      try {
        const variantsData = card.getAttribute('data-variant-options');
        const optionMapData = card.getAttribute('data-option-map');
        if (!variantsData || !optionMapData) return;

        const variants = JSON.parse(variantsData);
        const optionMap = JSON.parse(optionMapData);

        // Filter variants by country SKU suffix
        const countrySuffix = '_' + targetCountryLower;
        const matchingVariants = variants.filter(v => {
          if (!v.s) return false;
          return v.s.toLowerCase().endsWith(countrySuffix);
        });

        // Determine which option positions map to size/flavor/color
        let sizePosKey = null, flavorPosKey = null, colorPosKey = null;

        for (const [name, pos] of Object.entries(optionMap)) {
          const n = name.toLowerCase();
          if (n === 'size' || n === 'sizes') sizePosKey = 'o' + pos;
          else if (n === 'flavor' || n === 'flavors' || n === 'flavour' || n === 'flavours') flavorPosKey = 'o' + pos;
          else if (n === 'color' || n === 'colors' || n === 'colour' || n === 'colours') colorPosKey = 'o' + pos;
        }

        // Count unique values for each option type from matching variants
        const sizeValues = new Set();
        const flavorValues = new Set();
        const colorValues = new Set();

        matchingVariants.forEach(v => {
          if (sizePosKey && v[sizePosKey]) sizeValues.add(v[sizePosKey]);
          if (flavorPosKey && v[flavorPosKey]) flavorValues.add(v[flavorPosKey]);
          if (colorPosKey && v[colorPosKey]) colorValues.add(v[colorPosKey]);
        });

        // Find the option tags container within this card
        const container = card.querySelector('.product-option-tags');
        if (!container) return;

        // Update or create badge elements
        const tags = container.querySelectorAll('.product-option-tag');

        // Read translated labels from data attributes (set by product-option-tags.liquid via | t)
        const sizeSingular = container.getAttribute('data-size-singular') || 'Size';
        const sizePlural = container.getAttribute('data-size-plural') || 'Sizes';
        const flavorSingular = container.getAttribute('data-flavor-singular') || 'Flavor';
        const flavorPlural = container.getAttribute('data-flavor-plural') || 'Flavors';
        const colorSingular = container.getAttribute('data-color-singular') || 'Color';
        const colorPlural = container.getAttribute('data-color-plural') || 'Colors';

        tags.forEach(tag => {
          const type = tag.getAttribute('data-option-type');
          if (type === 'size') {
            if (sizeValues.size > 0) {
              tag.textContent = sizeValues.size + ' ' + (sizeValues.size === 1 ? sizeSingular : sizePlural);
              tag.style.display = '';
            } else {
              tag.style.display = 'none';
            }
          } else if (type === 'flavor') {
            if (flavorValues.size > 0) {
              tag.textContent = flavorValues.size + ' ' + (flavorValues.size === 1 ? flavorSingular : flavorPlural);
              tag.style.display = '';
            } else {
              tag.style.display = 'none';
            }
          } else if (type === 'color') {
            if (colorValues.size > 0) {
              tag.textContent = colorValues.size + ' ' + (colorValues.size === 1 ? colorSingular : colorPlural);
              tag.style.display = '';
            } else {
              tag.style.display = 'none';
            }
          }
        });

        // Hide entire container if no tags visible
        const anyVisible = Array.from(tags).some(t => t.style.display !== 'none');
        container.style.display = anyVisible ? '' : 'none';
      } catch (e) {
        console.error('Error updating option tags by country:', e);
      }
    });
  }

  // Update product card prices based on locale-matching variants.
  // data-variants contains "price" (TTC, with metafield tax already applied), "price_excl" (HT, raw),
  // and "catalog_vat_price" (cents from catalog_prices.VATPrice metafield, for international markets).
  // For EU/CA countries: uses "price" (tax_amount metafield applied in Liquid).
  // For all other international markets: uses "catalog_vat_price" when available.
  function updatePricesByLocale(targetCountryLower) {
    const cc = window.data && window.data.countryConfig;
    const firstContainer = document.querySelector('[data-locale-price="true"]');
    const currency = (firstContainer && firstContainer.getAttribute('data-currency-code')) || (cc && cc.currency) || 'USD';

    const urlLang = (window.location.pathname.match(/^\/([a-z]{2})-/) || [])[1] || '';

    const vatLabels = {
      FR: 'TTC', IT: 'IVA incl.', AT: 'inkl. MwSt.',
      BE: urlLang === 'nl' ? 'Incl. BTW' : urlLang === 'de' ? 'inkl. MwSt.' : 'TVA incl.',
      DE: 'inkl. MwSt.',
      CH: urlLang === 'fr' ? 'TTC' : urlLang === 'it' ? 'IVA incl.' : 'inkl. MwSt.',
      NL: 'Incl. BTW', ES: 'IVA incl.', GB: 'Incl. VAT'
    };
    const exclVatLabels = {
      FR: 'HT', IT: 'Escl. IVA', AT: 'Exkl. MwSt.',
      BE: urlLang === 'nl' ? 'Excl. BTW' : urlLang === 'de' ? 'Exkl. MwSt.' : 'HT',
      DE: 'Exkl. MwSt.',
      CH: urlLang === 'fr' ? 'HT' : urlLang === 'it' ? 'Escl. IVA' : 'Exkl. MwSt.',
      NL: 'Excl. BTW', ES: 'Excl. IVA', GB: 'Excl. VAT'
    };
    const country = (window.data && window.data.profile && window.data.profile.targetCountry || '').toUpperCase();
    const vatLabel = vatLabels[country] || '';
    const exclVatLabel = exclVatLabels[country] || '';

    // North America uses Shopify native prices (no catalog_prices metafield expected)
    const naCountries = ['US', 'CA', 'PR'];
    const useNativePrices = naCountries.includes(country);

    const collectionLocaleMap = {
      FR: 'fr-FR', IT: 'it-IT', AT: 'de-AT',
      BE: urlLang === 'nl' ? 'nl-BE' : urlLang === 'de' ? 'de-BE' : 'fr-BE',
      DE: 'de-DE',
      CH: urlLang === 'fr' ? 'fr-CH' : urlLang === 'it' ? 'it-CH' : 'de-CH',
      NL: 'nl-NL', ES: 'es-ES', GB: 'en-GB', TR: 'tr-TR',
      CA: 'en-CA', US: 'en-US', PR: 'en-US',
    };
    const collectionLocale = collectionLocaleMap[country] || 'en-US';

    function formatWithCurrency(cents) {
      return new Intl.NumberFormat(collectionLocale, { style: 'currency', currency: currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
    }

    const priceContainers = document.querySelectorAll('[data-locale-price="true"]');

    priceContainers.forEach(container => {
      try {
        const variantsData = container.getAttribute('data-variants');
        if (!variantsData) return;

        const variants = JSON.parse(variantsData);

        // Filter variants that match the target country and are active
        const matchingVariants = variants.filter(variant => {
          if (!variant.sku) return false;
          if (variant.is_active === false) return false;
          const skuParts = variant.sku.split('_');
          if (skuParts.length < 2) return false;
          return skuParts[skuParts.length - 1].toLowerCase() === targetCountryLower;
        });

        if (matchingVariants.length === 0) return;

        // For all non-NA markets: use catalog_vat_price (from catalog_prices.VATPrice metafield) when available.
        // This matches the product page behavior (enhanced-product-information.liquid) which uses catalog_prices
        // for all non-North America countries. For NA: use "price" (Shopify native price).
        const ttcPrices = matchingVariants.map(v => {
          if (!useNativePrices && v.catalog_vat_price != null) return v.catalog_vat_price;
          return v.price;
        });
        const minTtc = Math.min(...ttcPrices);
        const maxTtc = Math.max(...ttcPrices);

        // HT prices (VAT-excl). Prefer catalog_prices.RetailPrice metafield (non-NA) → fallback to tax-computed price_excl.
        const htPrices = matchingVariants.map(v => {
          if (!useNativePrices && v.catalog_retail_price != null) return v.catalog_retail_price;
          return v.price_excl != null ? v.price_excl : v.price;
        });
        const minHt = Math.min(...htPrices);
        const maxHt = Math.max(...htPrices);

        // Determine whether any locale variant has tax info. Presence of catalog_prices (non-NA) is definitive —
        // it matches the PDP which treats the metafield as proof VAT applies. Otherwise fall back to tax_amount.
        const hasTax = matchingVariants.some(v => {
          if (!useNativePrices && v.catalog_prices != null) return true;
          return v.price_excl != null && v.price !== v.price_excl;
        });

        // Debug: log what came from the catalog_prices metafield for this product card.
        console.log('[collection-price]', {
          product: container.closest('[data-product-handle]')?.getAttribute('data-product-handle') || container.getAttribute('data-min-variant'),
          country,
          matchingVariants: matchingVariants.map(v => ({
            sku: v.sku,
            price: v.price,
            price_excl: v.price_excl,
            catalog_vat_price: v.catalog_vat_price,
            catalog_retail_price: v.catalog_retail_price,
            catalog_prices: v.catalog_prices,
          })),
          computed: { minTtc, maxTtc, minHt, maxHt, hasTax, useNativePrices },
        });

        // Update data attributes with locale-filtered TTC prices
        container.setAttribute('data-min-cents', minTtc);
        container.setAttribute('data-max-cents', maxTtc);
        container.setAttribute('data-price-cents', minTtc);

        // --- Primary price (TTC) ---
        const formattedTtc = formatWithCurrency(minTtc);
        const priceElement = container.querySelector('.price, .price-from');
        if (priceElement) {
          if (minTtc !== maxTtc) {
            const fromPrefix = document.querySelector('results-list')?.getAttribute('data-from-price-prefix') || 'From';
            const toPrefix = document.querySelector('results-list')?.getAttribute('data-to-price-prefix') || 'to';
            const formattedMax = formatWithCurrency(maxTtc);
            priceElement.textContent = fromPrefix + ' ' + formattedTtc + ' ' + toPrefix + ' ' + formattedMax;
            priceElement.classList.add('price-from');
          } else {
            priceElement.textContent = formattedTtc;
            priceElement.classList.remove('price-from');
          }
        }

        // TTC label after main price (e.g. "TTC", "inkl. MwSt.")
        var existingVatLabel = container.querySelector('.price-vat-label');
        if (existingVatLabel) existingVatLabel.remove();

        if (hasTax && vatLabel) {
          var vatLabelEl = document.createElement('span');
          vatLabelEl.className = 'price-vat-label';
          vatLabelEl.textContent = '(' + vatLabel + ')';
          var insertAfterEl = container.querySelector('.price-from') || container.querySelector('.price:not(.price-from)');
          if (insertAfterEl && insertAfterEl.parentNode) {
            insertAfterEl.parentNode.insertBefore(vatLabelEl, insertAfterEl.nextSibling);
          }
          container.dataset.vatApplied = 'true';
        } else {
          delete container.dataset.vatApplied;
        }

        // --- Secondary price (HT / excl. VAT) ---
        // Replace the Liquid-rendered .price-excl-vat span (which uses the wrong global price_min)
        // with the correct locale-filtered HT price.
        var exclVatSpan = container.querySelector('.price-excl-vat');
        if (hasTax && exclVatLabel) {
          const formattedMinHt = formatWithCurrency(minHt);
          const fromPrefix = document.querySelector('results-list')?.getAttribute('data-from-price-prefix') || 'From';
          const toPrefix = document.querySelector('results-list')?.getAttribute('data-to-price-prefix') || 'to';
          const htText = (minHt !== maxHt)
            ? fromPrefix + ' ' + formattedMinHt + ' ' + toPrefix + ' ' + formatWithCurrency(maxHt) + '\u00a0' + exclVatLabel
            : formattedMinHt + '\u00a0' + exclVatLabel;
          if (exclVatSpan) {
            exclVatSpan.textContent = htText;
            exclVatSpan.style.display = '';
          } else {
            // Span not rendered by Liquid (e.g. selected variant had tax_rate=0) — create it
            var newExclVatSpan = document.createElement('span');
            newExclVatSpan.className = 'price-excl-vat';
            newExclVatSpan.textContent = htText;
            container.appendChild(newExclVatSpan);
          }
        } else if (exclVatSpan) {
          exclVatSpan.style.display = 'none';
        }
      } catch (e) {
        console.error('Error updating price by locale:', e);
      }
    });
  }

  // Show "no products" message when country filter hides all products
  function showNoProductsMessage() {
    const grid = document.querySelector('[ref="grid"]');
    if (!grid) return;

    grid.style.display = 'none';

    if (!document.getElementById('no-products-country-message')) {
      const noProductsText = document.querySelector('results-list')?.getAttribute('data-no-products-text') || 'No products found.';
      const emptyDiv = document.createElement('div');
      emptyDiv.id = 'no-products-country-message';
      emptyDiv.style.cssText = 'display:flex;justify-content:center;align-items:center;text-align:center;min-height:50vh;padding:2rem 1rem;';
      emptyDiv.innerHTML = '<h2 class="h2" style="margin:0;">' + noProductsText + '</h2>';
      grid.parentNode.insertBefore(emptyDiv, grid);
    }
  }

  function hideNoProductsMessage() {
    const msg = document.getElementById('no-products-country-message');
    if (msg) msg.remove();

    const grid = document.querySelector('[ref="grid"]');
    if (grid) grid.style.display = '';
  }

  // Product titles on the collection page are rendered by Liquid (blocks/product-title.liquid)
  // using locale translations and custom.product_name metafield — no JS needed here.
  function translateProductTitles() {}

  // Register a DMO gate so main.ts can wait for the grid reveal before unhiding the body.
  var _collectionGate = window.dmoGates && window.dmoGates.register('main-collection');

  // Reveal the product grid after filtering is complete.
  // The grid starts hidden (opacity: 0 via CSS) so products are never visible unfiltered.
  var _gridRevealed = false;
  function revealGrid() {
    if (_gridRevealed) return;
    _gridRevealed = true;
    var grid = document.querySelector('[ref="grid"]');
    if (grid) {
      grid.classList.add('collection-grid--ready');
    }
    if (_collectionGate) _collectionGate.signal();
  }

  // Run filtering + reveal.
  function runFiltering() {
    if (window.data && window.data.profile && window.data.profile.targetCountry) {
      filterProductCardsByTargetCountry();
      translateProductTitles();
    } else {
      // No country data — show all products as-is (fail-open).
      var productCards = document.querySelectorAll('.product-grid__item[data-product-skus]');
      productCards.forEach(function(card) { card.style.display = ''; });
      document.querySelectorAll('.product-option-tag[data-option-type="size"]').forEach(function(tag) { tag.style.display = ''; });
      hideNoProductsMessage();
    }
    revealGrid();
  }

  // Fallback: if dmo:data:loaded never fires within 4 seconds, reveal whatever we have.
  // This is slightly longer than the 3s body-show fallback so the page isn't blank
  // for any longer than necessary if the API is genuinely unavailable.
  var _filterFired = false;
  var _fallbackTimer = setTimeout(function() {
    if (!_filterFired) {
      _filterFired = true;
      runFiltering();
      // Keep retrying in the background in case data arrives late.
      setTimeout(function() {
        if (window.data && window.data.profile && window.data.profile.targetCountry) {
          filterProductCardsByTargetCountry();
          translateProductTitles();
        }
      }, 3000);
    }
  }, 4000);

  // Primary path: filter as soon as DMO data is available.
  // dmo:data:loaded fires before showBodyAfterJSLoad(), so the grid is filtered
  // before the body opacity transition starts — no visible flash.
  function onDataReady() {
    if (_filterFired) return;
    _filterFired = true;
    clearTimeout(_fallbackTimer);
    runFiltering();
  }

  document.addEventListener('dmo:data:loaded', onDataReady, { once: true });

  // Also handle the case where data is already set by the time DOMContentLoaded fires
  // (e.g., script runs after a cached API response).
  function init() {
    if (window.data && window.data.profile && window.data.profile.targetCountry) {
      onDataReady();
    }
    setupProductGridObserver();
    logLowestPriceVariant();
  }

  // Setup observer to re-filter when product grid changes (e.g., after sorting)
  function setupProductGridObserver() {
    var productGrid = document.querySelector('[ref="grid"]');
    if (!productGrid) return;

    var observer = new MutationObserver(function(mutations) {
      var hasSignificantChanges = mutations.some(function(m) {
        return m.type === 'childList' && m.addedNodes.length > 0;
      });
      if (hasSignificantChanges) {
        // Re-run filtering after content updates (sorting, pagination, etc.).
        // Grid is already visible at this point — just re-filter in place.
        if (window.data && window.data.profile && window.data.profile.targetCountry) {
          filterProductCardsByTargetCountry();
          translateProductTitles();
        }
      }
    });

    observer.observe(productGrid, { childList: true, subtree: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function logLowestPriceVariant(targetCountryLower) {
    const targetCountry = (targetCountryLower || '').toUpperCase();
    const localeSuffix = targetCountry ? '_' + targetCountry : null;

    const priceContainers = document.querySelectorAll('[data-variants][data-locale-price]');
    let lowestPrice = Infinity;
    let lowestEntry = null;

    priceContainers.forEach(el => {
      const card = el.closest('[data-product-handle]');
      const productHandle = card ? card.getAttribute('data-product-handle') : 'unknown';

      try {
        const variants = JSON.parse(el.getAttribute('data-variants'));

        // Filter to only active, locale-matching variants
        const localeVariants = variants.filter(v => {
          if (!v.sku || v.is_active === false) return false;
          return localeSuffix ? v.sku.toUpperCase().endsWith(localeSuffix) : true;
        });

        if (localeVariants.length === 0) return;

        const minVariant = localeVariants.reduce((min, v) => v.price < min.price ? v : min, localeVariants[0]);

        if (minVariant.price < lowestPrice) {
          lowestPrice = minVariant.price;
          lowestEntry = { product: productHandle, sku: minVariant.sku, price: minVariant.price, is_active: minVariant.is_active };
        }
      } catch (e) {
        // ignore parse errors
      }
    });

  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["release-notes-pdf"] && !Shopify.designMode) return;
  try {
    
  document.documentElement.classList.add('body--release-notes');
  document.body.classList.add('body--release-notes');

  (function() {
    var isMobile = /Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      || (navigator.maxTouchPoints > 1 && /Macintosh/i.test(navigator.userAgent));

    if (isMobile) {
      var iframe = document.getElementById('release-notes-iframe');
      if (iframe) {
        var pdfUrl = iframe.getAttribute('data-pdf-url');
        iframe.src = 'https://docs.google.com/gview?url=' + encodeURIComponent(pdfUrl) + '&embedded=true';
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
